import { render, staticRenderFns } from "./ClinicianReport.vue?vue&type=template&id=327bb83e&scoped=true&"
import script from "./ClinicianReport.vue?vue&type=script&lang=js&"
export * from "./ClinicianReport.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianReport.vue?vue&type=style&index=0&id=327bb83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bb83e",
  null
  
)

export default component.exports